// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3kZOb","footer":"ModalCreateQualiphyProcedure_footer__1RXK0","additionData":"ModalCreateQualiphyProcedure_additionData__1MafJ"};